import { NeutPosition } from "../../neuten/neut/neut-position";
import { NeutDto } from "../api-models/neutDto";

export interface NeutModel {
  neut: string;
  omschrijving: string;
  sponningmaat: number;

  maatA: number;
  maatZ: number;
  daagmaat: number;
  sponningsoort: string;
  //positie: 'Links' | 'Rechts' | 'Tussen';
  position: NeutPosition;
  glaslat: string;
  beglazingsprofiel: string,
  aanslagprofiel: string,
  gemonteerd: boolean,
  damverbreeding: number,
  dubbelAanslagprofiel: number,
  linksVoorsponning: VorsponningSize;
  rechtsVoorsponning: VorsponningSize;
  customWidth?: number
}

export interface VorsponningSize {
  width: number;
  height: number;
}

export const VOORSPONNING_SIZE_MAP = Object.freeze({
  "6x6": {
    width: 6,
    height: 6
  },
  "8x8": {
    width: 8,
    height: 8
  },
  "6x19": {
    width: 6,
    height: 19
  },
  "8x19": {
    width: 8,
    height: 19
  },
  "6": {
    width: 6,
    height: null
  },
  "8": {
    width: 8,
    height: null
  }
});

export class NeutUtils {
  public static getNeutPositionFromString(pos: string): NeutPosition {
    let position = NeutPosition.Left;
    switch (pos) {
      case "Tussen":
        position = NeutPosition.Center;
        break;
      case "Rechts":
        position = NeutPosition.Right;
        break;
      default:
        position = NeutPosition.Left;
    }
    return position;
  }

  public static getPositionString(position: NeutPosition): string {
    switch (position) {
      case NeutPosition.Center:
        return "Tussen";
      case NeutPosition.Right:
        return "Rechts";
    }
    return "Links";
  }

  public static getPositionFromIndex(
    index: number,
    count: number
  ): NeutPosition {
    if (index === 0) {
      return NeutPosition.Left;
    }
    if (index === count - 1) {
      return NeutPosition.Right;
    }
    return NeutPosition.Center;
  }

  public static isRegular(neutDescription: string): boolean {
    let description = neutDescription.toLocaleLowerCase();
    return !this.isWissel(description) && !this.isDraaikiep(description) && !this.isSpecial(description);
  }

  public static isRegularTussen(neutDescription: string, positie?: string): boolean {
    let description = neutDescription.toLocaleLowerCase();
    let position = positie.toLocaleLowerCase();
    return this.isRegular(description) && (description.indexOf("tussen") !== -1 || position === "tussen");
  }

  public static isRegularRight(neutDescription: string, positie?: string): boolean {
    let description = neutDescription.toLocaleLowerCase();
    let position = positie.toLocaleLowerCase();
    return this.isRegular(description) && (description.indexOf("rechts") !== -1 || position === "rechts");
  }

  public static isWissel(neutDescription: string): boolean {
    let description = neutDescription.toLocaleLowerCase();
    return description.indexOf("w") === 0;
  }

  public static isDraaikiep(neutDescription: string): boolean {
    let description = neutDescription.toLocaleLowerCase();
    return description.indexOf("dk") !== -1;
  }

  public static isSpecial(neutDescription: string): boolean {
    let description = neutDescription.toLocaleLowerCase();
    return description.indexOf("x") !== -1;
  }

  public static isDK(neutDescription: string): boolean {
    let description = neutDescription.toLocaleLowerCase();
    return description.indexOf("dk") !== -1;
  }

  public static isDKLeft(neutDescription: string): boolean {
    let description = neutDescription.toLocaleLowerCase();
    return description.indexOf("dk") !== -1 && description.indexOf("eindneut") !== -1 && description.indexOf("links") !== -1;
  }

  public static isDKRight(neutDescription: string): boolean {
    let description = neutDescription.toLocaleLowerCase();
    return description.indexOf("dk") !== -1 && description.indexOf("eindneut") !== -1 && description.indexOf("rechts") !== -1;
  }

  public static isDKMidRight(neutDescription: string): boolean {
    let description = neutDescription.toLocaleLowerCase();
    return description.indexOf("dk") !== -1 && description.indexOf("tussen") !== -1 && description.indexOf("rechts") !== -1;
  }

  public static isDKMidLeft(neutDescription: string): boolean {
    let description = neutDescription.toLocaleLowerCase();
    return description.indexOf("dk") !== -1 && description.indexOf("tussen") !== -1 && description.indexOf("links") !== -1;
  }

  public static isDKMidBoth(neutDescription: string): boolean {
    let description = neutDescription.toLocaleLowerCase();
    return description.indexOf("dk") !== -1 && description.indexOf("tussen") !== -1 && (description.indexOf("ls+rs") !== -1 || description.indexOf("ls + rs") !== -1);
  }

  public static isW5(neutDescription: string): boolean {
    let description = neutDescription.toLocaleLowerCase();
    return description.indexOf("w5") !== -1;
  }

  public static isW3(neutDescription: string): boolean {
    let description = neutDescription.toLocaleLowerCase();
    return description.indexOf("w3") !== -1;
  }

  public static isW2(neutDescription: string): boolean {
    let description = neutDescription.toLocaleLowerCase();
    return description.indexOf("w2") !== -1;
  }

  public static isW1(neutDescription: string): boolean {
    let description = neutDescription.toLocaleLowerCase();
    return description.indexOf("w1") !== -1;
  }

  public static isW4(neutDescription: string): boolean {
    let description = neutDescription.toLocaleLowerCase();
    return description.indexOf("w4") !== -1;
  }

  //NOT IN USE ANYMORE

  // public static getDimensionFromCode(neutenCode: string): number { 
  //   //"N6351.L90.B" code example for left 90mm
  //   let splitCodeValues = neutenCode.split(".");
  //   let positionAndSize = splitCodeValues[1];
  //   let size = parseInt(positionAndSize.slice(-2));
  //   return size;
  // }

  // private getNumericValueFromNeutCode(code: string): number {
  //   const split = code.split('.');
  //   if (split.length !== 3) return 0;
  //   let codePart = split[1];
  //   let nr = parseInt(codePart);
  //   let index = 0;
  //   while (Number.isNaN(nr)) {
  //     codePart = codePart.substr(++index);
  //     nr = parseInt(codePart);
  //   }
  //   return nr;
  // }

  public static getLabel(index: number, count: number, isSlidingDoor?: boolean): string {
    if (index === 0) {
      // return isSlidingDoor ? "Neut" : "Linkerneut";
      return "Linkerneut";
    }
    if (index === count - 1) {
      return "Rechterneut";
    }
    return "Middenneut " + index;
  }

  public static getVoorsponningOptions(
    isLeftVakConversion: boolean,
    isRightVakConversion: boolean,
    isSpecialCaseException: boolean,
    isBinnenDorpel: boolean,
    isBuitenDorpel: boolean) {
    let leftOptions: string[] = [];
    let rightOptions: string[] = [];
    if (isBinnenDorpel || isLeftVakConversion) {
      leftOptions = ["6x6", "8x8"];
      if (isSpecialCaseException) {
        leftOptions.push(...["6x19", "8x19"])
      }
    } else if (isBuitenDorpel) {
      leftOptions = ["6x19", "8x19"];
    } else {
      leftOptions = ["6", "8"];
    }

    if (isBinnenDorpel || isRightVakConversion) {
      rightOptions = ["6x6", "8x8"];
      if (isSpecialCaseException) {
        rightOptions.push(...["6x19", "8x19"])
      }
    } else if (isBuitenDorpel) {
      rightOptions = ["6x19", "8x19"];
    } else {
      rightOptions = ["6", "8"];
    }

    return {
      leftOptions,
      rightOptions
    }
  }

  public static getVorsponningValue(vorsponning?: VorsponningSize): string {
    if (!vorsponning) {
      return;
    }
    let keys = Object.keys(VOORSPONNING_SIZE_MAP);
    for (let i = 0; i < keys.length; i++) {
      const crtVorsponning = VOORSPONNING_SIZE_MAP[keys[i]];

      if (crtVorsponning.width === vorsponning.width && crtVorsponning.height === vorsponning.height) {
        return keys[i];
      }
    }
  }

  public static getDrawingCoorodatesList(tekeningString: string, rtlOffset: number, xOffset?: number, yOffset?: number): Array<{ x: number, y: number }> {
    let pointsList = tekeningString.split("/");
    let result = [];
    /**
     * if second coordinate has a negative x value, this means that the neut is drawn from Right to Left
     * in this scenario, we add the neut width to each x coordinate to shift it back into place as it was LTR
     */
    let isDrawingRTL = parseInt(pointsList[1].split(",")[0]) < 0;
    let isDrawingHalves = pointsList[pointsList.length - 1] !== "0,0";

    pointsList.forEach(point => {
      let coordinates = point.split(",");
      result.push({
        x: parseInt(coordinates[0]) + (xOffset || 0) + (isDrawingRTL ? (isDrawingHalves ? rtlOffset / 2 : rtlOffset) : 0),
        y: parseInt(coordinates[1]) + (yOffset || 0)
      });
    });

    return result;
  }
}
